import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const classes = {
    ellipsis: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
};

const TypographyWithIcon = React.forwardRef(
    ({ icon, alignItems, children, ...props }, ref) => {
        return (
            <Typography
                {...props}
                style={Object.assign(
                    {
                        display: 'flex',
                        alignItems: alignItems || 'center',
                    },
                    props.style
                )}
                ref={ref}
            >
                <span
                    style={{
                        marginRight: '0.5rem',
                        display: 'inline-flex',
                        alignItems: 'center',
                    }}
                >
                    {icon}
                </span>
                <span style={classes.ellipsis}>{children}</span>
            </Typography>
        );
    }
);

TypographyWithIcon.displayName = 'TypographyWithIcon';

TypographyWithIcon.propTypes = {
    icon: PropTypes.element.isRequired,
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
    alignItems: PropTypes.string,
};

export default TypographyWithIcon;
